import FileTemplate from "./templates/FileTemplate";
import GeneratedTemplate from "./templates/GeneratedTemplate";
import ParametersTemplate from "./templates/ParametersTemplate";
import PropTypes from "prop-types";
import React from "react";
import { BackboneSelectionTable } from "lib/common/selectiontable/SelectionTable";
import { backboneConnect } from "lib/common/hoc/BackboneReact/backboneConnect";
import { appAlert } from "lib/withOver";
import useFluxStore from "@armus/use-flux-store";
import organizationsStore from "data/organizationsStore";

const OrgLookupContext = React.createContext({});

export function useOrgLookup() {
    return React.useContext(OrgLookupContext);
}

export function ResultsView(props) {
    const orgLookup = useFluxStore(
        () => organizationsStore.getKeyLookup(),
        [organizationsStore],
    );
    const fields = new Backbone.Collection([
        {
            name: "Generated",
            key: "Generated",
            type: "template",
            itemTemplate: GeneratedTemplate,
        }, {
            name: "File Type",
            key: "typeName",
            type: "string",
        }, {
            name: "Username",
            key: "username",
            type: "string",
        }, {
            name: "Parameters",
            key: "parameters",
            type: "template",
            itemTemplate: ParametersTemplate,
        }, {
            name: "Number of Records",
            key: "recordCount",
            type: "string",
        }, {
            name: "File",
            key: "file",
            type: "template",
            itemTemplate: FileTemplate,
        }, {
            name: "Status",
            key: "status",
            type: "string",
        },
    ]);

    return <OrgLookupContext.Provider value={orgLookup}>
        <BackboneSelectionTable
            {...props}
            sorts={new Backbone.Model({})}
            sortable={false}
            fields={fields} />
    </OrgLookupContext.Provider>;

}

ResultsView.propTypes = {
    model: PropTypes.instanceOf(Backbone.Model).isRequired,
    collection: PropTypes.instanceOf(Backbone.Collection).isRequired,
    hasHover: PropTypes.bool.isRequired
};

const noop = () => {/* noop */};

const config = props => ({
    collection: {
        listenOn: "collection",
        event: "all",
        get: () => props.collection
    },
    onSort: noop,
    onRecordSelection: noop,
    onDownloadClick: (data, event) => {
        event.preventDefault();

        const { view } = props,
              { recordCount, id, filename } = data;

        if (recordCount > 499) {
            appAlert({
                message: "This file contains more than 499 records. Please be aware that if you lose this file, you are required to report the loss of PHI in compliance with your organization's HIPAA policies and procedures.",
                spinner: false,
                actions: [
                    {
                        label: "Cancel",
                        callback: noop
                    },
                    {
                        label: "Ok",
                        callback: () => {
                            view.dispatch("get:hex_file_download", id, filename);
                        }
                    }
                ]
            });
        }
        else {
            view.dispatch("get:hex_file_download", id, filename);
        }
    }

});

export const BackboneResultsView = backboneConnect(config)(ResultsView);



// WEBPACK FOOTER //
// ./app/lib/hex/lib/resultsview/ResultsView.js